module.exports = __webpack_public_path__ + "static/media/flash.3bf0406c.svg";